import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLoader } from "../../../../context/LoaderProvider.jsx";

const Cateringtopresturent = () => {
    const [formData, setFormData] = useState({
        description: "",
        amount: "",
        startDate: "",
        endDate: "",
    });

    const [topRatings, setTopRatings] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const { showLoader, hideLoader } = useLoader();
    // ✅ Razorpay modal states
    const [payNowModal, setPayNowModal] = useState(false);
    const [loadingPayNow, setLoadingPayNow] = useState(false);
    const [payNowAmount, setPayNowAmount] = useState(0);
    const [selectedCouponId, setSelectedCouponId] = useState(null);

    const vendorId = localStorage.getItem("vendorId");
    const token = localStorage.getItem("authToken");

    // Table cell style
    const tdStyle = {
        border: "1px solid #ccc",
        padding: "10px",
        textAlign: "center",
    };

    // ✅ Fetch all TopRated entries
    useEffect(() => {
        const fetchTopRatings = async () => {
            if (!vendorId || !token) {
                alert("Session expired. Please login again.");
                setLoading(false);
                return;
            }

            try {
                showLoader();
                const response = await axios.get(
                    `https://backend.maamaas.com/catering/api/toprated/catering/getby/${vendorId}`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                const data = Array.isArray(response.data)
                    ? response.data
                    : [response.data];

                setTopRatings(data);
            } catch (error) {
                console.error("❌ Error fetching TopRated data:", error);
                alert("Failed to fetch TopRated data");
            } finally {
                setLoading(false);
                hideLoader();
            }
        };

        fetchTopRatings();
    }, [vendorId, token]);

    // ✅ Handle form change
    const handleChange = (e) =>
        setFormData({ ...formData, [e.target.name]: e.target.value });

    // ✅ Submit new TopRated record
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.description || !formData.startDate || !formData.endDate) {
            alert("Please fill all fields before submitting.");
            return;
        }

        try {
            showLoader();

            const payload = {
                topratedId: 0, // always 0 for new entries
                description: formData.description,
                startDate: new Date(formData.startDate).toISOString(),
                endDate: new Date(formData.endDate).toISOString(),
                vendorId: Number(vendorId),
                paymentStatus: "INITIATED", // ✅ changed as per API spec
                transactionId: "string", // ✅ placeholder value per API spec
                orderId: "string" // ✅ placeholder value per API spec
            };


            const response = await axios.post(
                `https://backend.maamaas.com/catering/api/vendor/catering/toprated/add/${vendorId}`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                        Accept: "*/*"
                    }
                }
            );

            alert("✅ TopRated record added successfully!");
            setTopRatings((prev) => [...prev, response.data]);
            setShowModal(false);
            setFormData({ description: "", amount: "", startDate: "", endDate: "" });
        } catch (error) {
            console.error("❌ Error adding TopRated:", error);
            alert("Failed to add TopRated record.");
        } finally {
            hideLoader();
        }
    };


    // ✅ Fetch amount and open Pay Now modal
    const openPayNowModal = async (couponId) => {
        try {
            setLoadingPayNow(true);
            showLoader();
            const response = await axios.get(
                `https://backend.maamaas.com/catering/api/vendor/catering/toprated/get/${couponId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            // Ensure valid data
            const amountValue = response.data?.amount;
            if (!amountValue) throw new Error("Amount not found for this record.");

            setPayNowAmount(amountValue);
            setSelectedCouponId(couponId);
            setPayNowModal(true);
        } catch (error) {
            console.error("❌ Failed to fetch TopRated amount:", error);
            alert("Failed to fetch TopRated amount.");
        } finally {
            setLoadingPayNow(false);
            hideLoader();
        }
    };

    // ✅ Razorpay payment handler
    const handleRazorpayPayment = async () => {
        if (!selectedCouponId) {
            alert("No record selected for payment.");
            return;
        }

        try {
            const amountInPaise = Math.round(payNowAmount);

            const username = "rzp_live_RU5whSMu9rPV7s";
            const password = "khRC0vtSHCGHktyu62yekZp0";
            const basicAuth = btoa(`${username}:${password}`);

            // Step 1: Create order
            const { data: orderData } = await axios.post(
                "https://backend.maamaas.com/food/api/user/create-order",
                { amount: amountInPaise, currency: "INR", vendorId },
                { headers: { Authorization: `Basic ${basicAuth}` } }
            );

            if (!orderData?.orderId) throw new Error("Order ID not generated.");

            // Step 2: Open Razorpay modal
            const rzp = new window.Razorpay({
                key: username,
                amount: amountInPaise,
                currency: "INR",
                name: "Maamaa's House",
                description: "TopRated Payment",
                order_id: orderData.orderId,
                handler: async (response) => {
                    try {
                        const { razorpay_payment_id, razorpay_order_id } = response;

                        // Step 3: Capture payment
                        await axios.post(
                            "https://backend.maamaas.com/food/api/user/capture",
                            { paymentId: razorpay_payment_id, amount: amountInPaise, currency: "INR", vendorId },
                            { headers: { Authorization: `Basic ${basicAuth}` } }
                        );

                        // Step 4: Update backend payment record
                        await axios.put(
                            `https://backend.maamaas.com/catering/api/vendor/catering/toprated/updatepayment/${selectedCouponId}`,
                            {},
                            {
                                params: {
                                    vendorRequirementCouponId: selectedCouponId,
                                    transactionId: razorpay_payment_id,
                                    orderId: razorpay_order_id,
                                },
                                headers: { Authorization: `Bearer ${token}` },
                            }
                        );

                        alert("✅ Payment successful!");
                        setPayNowModal(false);
                    } catch (err) {
                        console.error("⚠️ Payment update failed:", err);
                        alert("Payment captured but backend update failed.");
                    }
                },
                prefill: {
                    name: "Vendor",
                    email: "vendor@example.com",
                    contact: "9999999999",
                },
                theme: { color: "#b15cd6" },
            });

            rzp.open();
        } catch (err) {
            console.error("❌ Razorpay Payment Error:", err);
            alert("Payment initialization failed.");
        }
    };

    return (
        <div style={{ maxWidth: "1200px", margin: "auto", }}>
            {/* ➕ Add Button */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "10px",
                }}
            >
                <button
                    style={{
                        padding: "10px 16px",
                        backgroundColor: "#1976d2",
                        color: "#fff",
                        border: "none",
                        borderRadius: "6px",
                        cursor: "pointer",
                        fontWeight: "bold",
                        fontSize: "clamp(12px, 2vw, 14px)",
                    }}
                    onClick={() => setShowModal(true)}
                >
                    + Add TopRated
                </button>
            </div>

            {/* 📋 Table */}
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                    <tr>
                        {["S.No", "Description", "Amount", "Start Date", "End Date", "Status", "Action"].map((head, i) => (
                            <th
                                key={i}
                                style={{
                                    border: "1px solid #ccc",
                                    padding: "10px",
                                    backgroundColor: "#b15cd6",
                                    color: "#fff",
                                    textAlign: "center",
                                }}
                            >
                                {head}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {loading ? (
                        <tr><td colSpan="7" style={{ textAlign: "center" }}>Loading...</td></tr>
                    ) : topRatings.length === 0 ? (
                        <tr><td colSpan="7" style={{ textAlign: "center" }}>No records found</td></tr>
                    ) : (
                        topRatings.map((item, index) => (
                            <tr key={item.topratedId}>
                                <td style={tdStyle}>{index + 1}</td>
                                <td style={tdStyle}>{item.description}</td>
                                <td style={tdStyle}>₹{item.amount}</td>
                                <td style={tdStyle}>{new Date(item.startDate).toLocaleDateString()}</td>
                                <td style={tdStyle}>{new Date(item.endDate).toLocaleDateString()}</td>
                                <td style={tdStyle}>{item.paymentStatus}</td>
                                <td style={tdStyle}>
                                    {item.paymentStatus === "SUCCESS" ? (
                                        <button disabled style={{ background: "gray", color: "white", borderRadius: "6px" }}>Paid</button>
                                    ) : (
                                        <button
                                            style={{ background: "#4caf50", color: "white", borderRadius: "6px", padding: "6px 12px" }}
                                            onClick={() => openPayNowModal(item.topratedId)}
                                        >
                                            Pay Now
                                        </button>
                                    )}
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>

            {/* 💳 Pay Now Modal */}
            {payNowModal && (
                <div style={modalOverlay}>
                    <div style={modalBox}>
                        <div style={modalHeader}>
                            <h3>Pay Now</h3>
                            <button onClick={() => setPayNowModal(false)}>✕</button>
                        </div>
                        {loadingPayNow ? (
                            <p>Loading...</p>
                        ) : (
                            <>
                                <p>Amount: ₹{payNowAmount}</p>
                                <button onClick={handleRazorpayPayment} style={payButton}>
                                    Proceed to Pay
                                </button>
                            </>
                        )}
                    </div>
                </div>
            )}

            {/* 📝 Add Record Modal */}
            {showModal && (
                <div style={modalOverlay}>
                    <div style={modalBox}>
                        <div style={modalHeader}>
                            <h3>Add TopRated</h3>
                            <button onClick={() => setShowModal(false)}>✕</button>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <input
                                type="text"
                                name="description"
                                placeholder="Description"
                                value={formData.description}
                                onChange={handleChange}
                                style={inputStyle}
                            />

                            <input
                                type="date"
                                name="startDate"
                                value={formData.startDate}
                                onChange={handleChange}
                                style={inputStyle}
                            />
                            <input
                                type="date"
                                name="endDate"
                                value={formData.endDate}
                                onChange={handleChange}
                                style={inputStyle}
                            />
                            <button type="submit" style={payButton}>Submit</button>
                        </form>
                    </div>
                </div>
            )}
            {/* <Topdata /> */}
            {/*  */}
        </div>
    );
};

// Styles
const modalOverlay = {
    position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
    background: "rgba(0,0,0,0.5)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000
};
const modalBox = { background: "#fff", padding: "20px", borderRadius: "10px", width: "400px" };
const modalHeader = { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" };
const payButton = { background: "#b15cd6", color: "#fff", padding: "10px 16px", borderRadius: "6px", border: "none", cursor: "pointer" };
const inputStyle = { width: "100%", padding: "8px", marginBottom: "10px", border: "1px solid #ccc", borderRadius: "4px" };

export default Cateringtopresturent;

